<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/guia4.webp" 
         data-stellar-background-ratio="0.5" 
         style="background-position: center; background-repeat: no-repeat; background-size: cover; height: 100vh; width: 100%;"
  style="background-image: url('assets/img/guia4.webp')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
        <div class="col-md-12 logo_gerencia">
            <img src="/assets/img/logo_grd.png" alt="" class="logo_gerencia_imagen" style="width: 150px;">
        </div>
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white">
          <h3 style="color: white">
            <span class="textodelgado">GUÍA DE INTERVENCIÓN</span><br>
            <span class="textogordo">EN INMUEBLES</span> <br>
            <!-- <span class="textodelgado"> del Centro Histórico del Cusco</span> -->
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>



<!-- MANUAL DE INTERVENCIÓN -->
<section class="welcome-section pt-80 pt-pd-60 pt-40" style="background-image: url('/assets/img/fondo-tomo11.png'); background-size: cover; background-position: center;">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 m-auto text-center">
        <div class="section-title-wrap">
          <h2>GUÍA DE INTERVENCION EN INMUEBLES DEL CENTRO HISTÓRICO DEL CUSCO</h2>
          <p class="mb-0" style="font-weight: 300;">
            <b>La Municipalidad Provincial del Cusco</b>, como entidad
            comprometida con la preservación y conservación del
            patrimonio cultural de nuestra ciudad, se complace en
            presentar este <b>Manual de Intervención en Inmuebles</b>.
            Así mismo la <b>Gerencia de Centro Histórico</b> tiene como misión
            principal velar por el cuidado y protección de los inmuebles
            históricos y patrimoniales que conforman nuestro querido
            Cusco. Reconocemos la importancia de mantener viva
            nuestra herencia arquitectónica y garantizar su legado para
            las generaciones futuras.
          </p>
          <br>
        </div>

        <div class="page-wrapper">
            <article class="port-details-page-wrap">
                <div class="port-details-header">
                    <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 3, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
                        <figure class="port-details-thumb-item">
                            <a href="assets/img/guia1.webp" class="btn-img-gallery">
                                <img src="assets/img/guia1.webp" alt="Portfolio">
                            </a>
                        </figure>
                        <figure class="port-details-thumb-item">
                          <a href="assets/img/guia2.webp" class="btn-img-gallery">
                              <img src="assets/img/guia2.webp" alt="Portfolio">
                          </a>
                        </figure>
                        <figure class="port-details-thumb-item">
                            <a href="assets/img/guia3.webp" class="btn-img-gallery">
                                <img src="assets/img/guia3.webp" alt="Portfolio">
                            </a>
                        </figure>
                    </div>
                </div>
            </article>
          </div>

        <div class="col-md-12" style="margin-top: 70px !important;">
            <h3 class="text-center">MANUAL DE INTERVENCIÓN EN INMUEBLES DEL CENTRO HISTÓRICO DEL CUSCO</h3>
            <p class="mb-0" style="font-weight: 300;">
                Este manual ha sido elaborado con la finalidad de proporcionar a profesionales, técnicos y ciudadanos, 
                las herramientas necesarias para llevar a cabo intervenciones adecuadas y respetuosas en los inmuebles de 
                nuestra ciudad; para mitigar los riesgos de desastres a los que nuestro patrimonio está expuesto debido a su alto 
                nivel de vulnerabilidad que presentan en la mayoria de casos.
            </p>
            <div style="display: flex; flex-direction: row; justify-content: center; width: 100%;">
                <a href="https://drive.google.com/uc?export=download&id=1bQ37Vz3GEezwVpOF10EtwFOycZpCDzt-" class="btn btn-brand" target="_blank" style="background-color:#821644;margin-top:30px;">Descargar la Guía de Intervención</a>
            </div>
            <br>
        </div>
      </div><!-- End Section title -->
    </div>
  </div>
</section>

<div class="page-wrapper" style="background-image: url('/assets/img/fondo-leyenda-catalogacion.png'); background-size: cover; background-position: center;">
  <div class="accordion-content-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12">
            <iframe style="width:100%;height:700px" src="https://online.anyflip.com/zdbmc/dpyk/index.html"  seamless="seamless" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true" ></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
.logo_gerencia_imagen{
    width: 150px !important;
}
.logo_gerencia{
    display: flex; 
    flex-direction: row; 
    justify-content: center; 
    width: 100px !important; 
    margin-top: 180px !important;
}
.textodelgado{
    font-weight: 100 !important;
    font-size: 25px;
}

.textogordo{
    font-weight: bolder !important;
    font-size: 25px;
}
@media only screen and (min-width: 768px) and (max-width: 991.98px), only screen and (max-width: 767.98px){
    .about-us-content {
            font-size: 14px;
            padding: 0px;
    }
    .logo_gerencia {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100px !important;
        margin-top: 250px !important;
        margin-bottom: -100px;
    }
}

@media (max-width: 425px){
    .logo_gerencia {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100% !important;
        margin-top: 140px !important;
        margin-bottom: 0px;
    }
    .logo_gerencia_imagen{
        width: 100px !important;
    }
    .textodelgado{
        font-weight: 100 !important;
        font-size: 17px;
    }
    .textogordo{
        font-weight: bolder !important;
        font-size: 17px;
    }
}
</style>